import { ModifierDetail } from "@/core/models";
import { BaseModifierPriceCalculationStrategy } from ".";

export class CashModifierPriceStrategy extends BaseModifierPriceCalculationStrategy {

  protected extractFactorPrice(modifierDetail: ModifierDetail): bigint {
    return BigInt(modifierDetail?.precioBase ?? 0n);
  }
}